import Vue from 'vue';
import Vuetify from 'vuetify/lib';
/*import colors from 'vuetify/lib/util/colors'*/
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#000000', // #E53935
          secondary: '#B2DACD',
          accent: '#FE781E', // #3F51B5
          buttonGreen:process.env.VUE_APP_COLOR_BUTTON_GREEN,
          buttonGreenDark:process.env.VUE_APP_COLOR_BUTTON_GREEN_DARK,
          buttonRed:process.env.VUE_APP_COLOR_BUTTON_RED,
          // buttonGrey:'rgba(0,0,0,0.8)',
          espotoYellow: '#F7F6EF',
          espotoYellow2: '#fff6c1',
          espotoPurple: '#763299',
          espotoGrey: '#e6eaef',
          transparent: '#00000000',
          backgroundColor: process.env.VUE_APP_COLOR_BACKGROUND,
          textColor: process.env.VUE_APP_COLOR_TEXT,
          btnColorPrimary: process.env.VUE_APP_COLOR_BTN_PRIMARY,
          btnSecondary: process.env.VUE_APP_COLOR_BTN_SECONDARY,
          btnTextColor: process.env.VUE_APP_COLOR_BTN_TEXT,
          headerFooterColor: process.env.VUE_APP_COLOR_HEADER_FOOTER,
          footerIconColor: process.env.VUE_APP_COLOR_FOOTER_ICON,
          footerIconSelectedColor: process.env.VUE_APP_COLOR_FOOTER_ICON_SELECTED

          /*
          error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',*/
        },
      },
    },
  });
  
